import { render, staticRenderFns } from "./targetCollocate.vue?vue&type=template&id=5ab6aeb9&scoped=true&"
import script from "./targetCollocate.vue?vue&type=script&lang=js&"
export * from "./targetCollocate.vue?vue&type=script&lang=js&"
import style0 from "./targetCollocate.vue?vue&type=style&index=0&id=5ab6aeb9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab6aeb9",
  null
  
)

export default component.exports